module.exports = __webpack_public_path__ + "static/6-8ba2266257de50b69ded611350deec93.jpg";